var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('vertical-form-table', _vm._b({
    on: {
      "input": _vm.emit
    },
    scopedSlots: _vm._u([{
      key: "연락처",
      fn: function fn() {
        return [_c('v-row', {
          attrs: {
            "align": "center"
          }
        }, [_c('v-col', [_c('v-phone-field', {
          attrs: {
            "outlined": ""
          },
          on: {
            "input": _vm.emit
          },
          model: {
            value: _vm.form.recruiter.phone,
            callback: function callback($$v) {
              _vm.$set(_vm.form.recruiter, "phone", $$v);
            },
            expression: "form.recruiter.phone"
          }
        })], 1), _c('v-col', {
          attrs: {
            "cols": "12",
            "md": "auto"
          }
        }, [_c('v-checkbox', {
          attrs: {
            "label": "비노출",
            "dense": "",
            "inset": "",
            "hide-details": ""
          },
          on: {
            "input": _vm.emit
          },
          model: {
            value: _vm.form.recruiter.hidesPhone,
            callback: function callback($$v) {
              _vm.$set(_vm.form.recruiter, "hidesPhone", $$v);
            },
            expression: "form.recruiter.hidesPhone"
          }
        })], 1)], 1)];
      },
      proxy: true
    }, {
      key: "이메일",
      fn: function fn() {
        return [_c('v-row', {
          attrs: {
            "align": "center"
          }
        }, [_c('v-col', [_c('v-email-field', {
          attrs: {
            "outlined": ""
          },
          on: {
            "input": _vm.emit
          },
          model: {
            value: _vm.form.recruiter.email,
            callback: function callback($$v) {
              _vm.$set(_vm.form.recruiter, "email", $$v);
            },
            expression: "form.recruiter.email"
          }
        })], 1), _c('v-col', {
          attrs: {
            "cols": "12",
            "md": "auto"
          }
        }, [_c('v-checkbox', {
          attrs: {
            "label": "비노출",
            "dense": "",
            "inset": "",
            "hide-details": ""
          },
          on: {
            "input": _vm.emit
          },
          model: {
            value: _vm.form.recruiter.hidesEmail,
            callback: function callback($$v) {
              _vm.$set(_vm.form.recruiter, "hidesEmail", $$v);
            },
            expression: "form.recruiter.hidesEmail"
          }
        })], 1)], 1)];
      },
      proxy: true
    }]),
    model: {
      value: _vm.form,
      callback: function callback($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }, 'vertical-form-table', {
    items: _vm.items
  }, false));
}
var staticRenderFns = []

export { render, staticRenderFns }